import React from 'react'

class SelectBox extends React.Component {

  checkedClass = () => {
    return this.props.checked ? 'active' : ''
  }

  onChange = () => {
    const {
      onChange,
      value,
    } = this.props;
    onChange(value)
  }

  render() {
    const {
      value,
      text,
      checked
    } = this.props
    return (
      <div  onClick={this.onChange} className={`card card-border card-btn ${this.checkedClass()}`}>
        <div className='custom-control custom-radio'>
          <input
            className='custom-control-input'
            type='radio'
            checked={ checked }
            value={value}
            onChange={ this.onChange }
          />
          <label className='custom-control-label'>
            { text }
          </label>
        </div>
      </div>
    )
  }
}

export default SelectBox;
